import Bundle from "@framework/Bundle";

export const routes = require.context(
	"./",
	true,
	/.*\/@module($|\/routes\.(js))/
);

/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-START */
/* REMOVE-FOR-CLIENT-SSR-START */
export const controllers = [{value: () => import(/* webpackPreload: true */ "./@module/controller.js"), path: "./@module/controller.js"}];
export const models = [];
/* REMOVE-FOR-CLIENT-SSR-END */
export const libs = [{value: () => import(/* webpackPreload: true */ "./@libs/FAQ.js"), path: "./@libs/FAQ.js"}, {value: () => import(/* webpackPreload: true */ "./@libs/Service.js"), path: "./@libs/Service.js"}];
export const styles = [];
export const constants = [];
export const loadable = require.context("./", true, /\.(loadable)\.(js)$/);
export const stores = [{value: () => import(/* webpackPreload: true */ "./@stores/FAQ.store.js"), path: "./@stores/FAQ.store.js"}, {value: () => import(/* webpackPreload: true */ "./@stores/FAQTable.store.js"), path: "./@stores/FAQTable.store.js"}, {value: () => import(/* webpackPreload: true */ "./@stores/Modals/CreateFAQModal.store.js"), path: "./@stores/Modals/CreateFAQModal.store.js"}, {value: () => import(/* webpackPreload: true */ "./@stores/Modals/UpdateFAQModal.store.js"), path: "./@stores/Modals/UpdateFAQModal.store.js"}];
export const extensions = [];
export const background = require.context("./", true, /\.(background)\.(js)$/);
/* webpack-strip-block:removed */
/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-END */
